import styled from '@emotion/styled';

export const CustomSelect = styled.div<{
    $currentColors: any;
    $styleProps: any;
}>`
    .react-select__control {
        align-items: center;
        opacity: 1;
        border-bottom-left-radius: ${({ $styleProps }) =>
            $styleProps?.borderBottomLeftRadius || '4px'};
        border-bottom-right-radius: ${({ $styleProps }) =>
            $styleProps?.borderBottomRightRadius || '4px'};
        border-radius: ${({ $styleProps }) =>
            $styleProps?.borderRadius || '4px'};
        background-color: ${({ $styleProps, $currentColors }) =>
            $styleProps.backgroundColor || $currentColors.componentBg};
        border-color: ${({ $styleProps, $currentColors }) =>
            $styleProps.borderColor || $currentColors.brand['700']};
        width: ${({ $styleProps }) => $styleProps?.width || '100%'};
        min-width: ${({ $styleProps }) =>
            $styleProps?.minWidth || $styleProps?.width || '100%'};
        max-width: ${({ $styleProps }) =>
            $styleProps?.maxWidth || $styleProps?.width || '100%'};
        width: ${({ $styleProps }) => $styleProps?.width || '100%'};
        height: max-content;
        min-height: ${({ $styleProps }) =>
            $styleProps?.minHeight || $styleProps?.height || '30px'};
        max-height: max-content;
        box-shadow: ${({ $styleProps, $currentColors }) =>
            $styleProps?.boxShadow || 'none'};
        border-width: ${({ $styleProps }) => $styleProps?.borderWidth || '1px'};
        color: ${({ $styleProps }) =>
            $styleProps?.color || $styleProps?.headingText};
    }

    .react-select__control:hover {
        border-color: ${({ $styleProps, $currentColors }) =>
            $styleProps.borderColor || $currentColors.brand['700']};
    }
    .react-select__control:focus {
        border-color: ${({ $styleProps, $currentColors }) =>
            $styleProps.borderColor || $currentColors.brand['700']};
    }

    .react-select__control--is-disabled {
        opacity: 0.6;
    }

    .react-select__multi-value__label {
        padding: 3px 3px 3px;
        line-height: 12px;
    }
`;
